class ExtendedError extends Error {
    constructor(message, code, errorObj) {
        super(message, code, errorObj);
        this.message = message;
        this.name = "ExtendedError";
        this.code = code;
        this.errorObj = errorObj;
    }

    // Can add validation functions here, ie: //
    message(){
        return this.message;
    }
    name(){
        return this.name;
    }
    code(){
        return this.code;
    }
    errorObj(){
        return this.errorObj;
    }
}
export default ExtendedError;